import React from 'react';

import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default class Field {
  constructor(key, label = '', options = {}) {
    this.key = key;
    this.label = label;
    this.options = options;
    this.ref = React.createRef();
  }

  hasValue(data) {
    return data && !!data[this.key];
  }

  getKey() {
    return this.key;
  }

  getValue(data) {
    return data ? data[this.key] || '' : '';
  }

  #getFormattedValue(data) {
    return this.options.formatter
      ? this.options.formatter(this.getValue(data))
      : this.getValue(data);
  }

  #renderContentValue(formattedValue, inValidData, hasOriginalValue) {
    const label = (
      <Text
        color="tertiary"
        component={this.options.label?.component || 'span'}
        size={this.options.label?.variant || 'xs'}
        uppercase
      >
        {this.label}
      </Text>
    );
    switch (true) {
      case !formattedValue && inValidData: // no has data and it is a required validate field
        return (
          <Stack spacing="6px">
            {label}
            <Stack
              alignItems="center"
              direction="row"
            >
              <SharedAsset
                alt=""
                src="/icon/micro/alert-fill.svg"
              />
              <Text
                aria-label="missing error"
                color="red"
                component={this.options.component || 'div'}
                marginLeft="8px"
                size={this.options.variant || 'md'}
              >
                Contact us to update
              </Text>
            </Stack>
          </Stack>
        );
      // has data and it is a required validate field and invalid data
      case formattedValue && inValidData:
        return (
          <Stack direction="column">
            {label}
            <Text
              component={this.options.component || 'div'}
              size={this.options.variant || 'md'}
            >
              {formattedValue}
            </Text>
            {
              // If the field has formatted value, but does not have original value
              // we don't show the `invalid` message
              // that mean it shows the formatted value/ placeholder value or something like that
              hasOriginalValue && (
                <Stack
                  alignItems="center"
                  direction="row"
                  mt="6px"
                >
                  <SharedAsset
                    alt=""
                    src="/icon/micro/alert-fill.svg"
                  />
                  <Text
                    aria-label="invalid error"
                    color="red"
                    component={this.options.component || 'div'}
                    marginLeft="4px"
                    size={this.options.variant || 'md'}
                  >
                    Invalid
                  </Text>
                </Stack>
              )
            }
          </Stack>
        );

      case formattedValue && !inValidData: // a normal field (no required for validate)
        return (
          <Stack spacing="6px">
            {label}
            <Stack direction="column">
              <Text
                component={this.options.component || 'div'}
                size={this.options.variant || 'md'}
                sx={{ wordBreak: 'break-word' }}
                wrap="pretty"
              >
                {formattedValue}
              </Text>
            </Stack>
          </Stack>
        );
      default:
        return '';
    }
  }

  getReadOnlyField(data, inValidData) {
    const formattedValue = this.#getFormattedValue(data);
    const hasOriginalValue = this.hasValue(data);

    return (
      <Box
        key={this.label}
        mt="24px"
      >
        {this.#renderContentValue(formattedValue, inValidData, hasOriginalValue)}
      </Box>
    );
  }
}
